import api from "@/utils/axios";

const state = () => ({});

const getters = {};

const mutations = {};

const actions = {
  async getLicences() {
    try {
      const response = await api.get("/licenses");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createNewLicences(_, { data }) {
    try {
      const response = await api.post("/licenses", {licenseBase64: data} );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async requestLicense(_, { appsNames }) {
    try {
      // El backend espera un LicenseNotificationRequestDto { ApplicationIdentifier }
      // por petición. Se envía una solicitud por cada app seleccionada.
      const apps = Array.isArray(appsNames) ? appsNames : [appsNames];
      const responses = await Promise.all(
        apps.map((name) =>
          api.post("/licenses/request_license", { applicationIdentifier: name })
        )
      );
      return responses.map((r) => r.data);
    } catch (error) {
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
